import { IntegrationConfig } from 'models/integrationConfig';
import { createContext } from 'react';

interface IntegrationContextProps {
  currentIntegrations: IntegrationConfig[];
}

export const IntegrationVariables: IntegrationContextProps = {
  currentIntegrations: [],
};

export default createContext(IntegrationVariables);
